/* eslint-disable no-undef */
import React, {ReactNode} from 'react';
import {ApolloClient} from '@apollo/client';
import {NormalizedCacheObject} from '@apollo/client/cache';

interface Props {
  apolloClient: ApolloClient<NormalizedCacheObject>;
  children: ReactNode;
}
export const EzRailsUploadApolloClientContext = React.createContext<{
  apolloClient?: ApolloClient<NormalizedCacheObject>;
}>({
  apolloClient: undefined,
});

export const EzRailsUploadApolloClientProvider = ({children, apolloClient}: Props): JSX.Element => {
  return (
    <EzRailsUploadApolloClientContext.Provider value={{apolloClient}}>
      {children}
    </EzRailsUploadApolloClientContext.Provider>
  );
};
